<app-offices-section></app-offices-section>
<!--<app-about-section></app-about-section>-->
<!--<app-slider-section></app-slider-section>-->
<!--<app-pricing-section></app-pricing-section>-->
<!--<app-video-section></app-video-section>-->
<!--<app-options-section></app-options-section>-->
<!--<app-services-section></app-services-section>-->
<!--<app-contacts-section></app-contacts-section>-->
<!--<app-map-section></app-map-section>-->
